import React, { useState, useCallback, useContext } from 'react';

import { useNotifications } from 'reapop';
import { isEmpty } from 'ramda';

import RegistrationPage from '../components/RegistrationPage';
import RegistrationPageCTA from '../contexts/Registration.context';

const RegistrationPageContainer = () => {
  const { close = {}, cache: { openJobsLink } = {} } = useContext(
    RegistrationPageCTA.CTA,
  );
  const [checked, setChecked] = useState('');
  const [sourceType, setSourceType] = useState('');
  const [error, setError] = useState('');
  const { notify } = useNotifications();

  const handleSelect = (e, { value }) => setChecked(value);

  const handleInputChange = useCallback(event => {
    setError('');
    setSourceType(event?.target?.value);
  }, []);

  const redirectToRegister = () => {
    if (isEmpty(checked)) {
      notify('Please specify source', 'error');
      return;
    }
    if (checked === 'other') {
      if (isEmpty(sourceType)) {
        setError('Please specify source');
        return;
      }
      const url = openJobsLink
        ? `${openJobsLink}&source=${sourceType}`
        : `https://tesavirtualfairjobs.snaphunt.com?source=${sourceType}`;
      window.open(url);
    }
    const url = openJobsLink
      ? `${openJobsLink}&source=${checked}`
      : `https://tesavirtualfairjobs.snaphunt.com?source=${checked}`;
    window.open(url);
  };

  return (
    <RegistrationPage
      onClose={close}
      onSelect={handleSelect}
      error={error}
      onInputChange={handleInputChange}
      redirectToRegister={redirectToRegister}
      checked={checked}
      sourceType={sourceType}
    />
  );
};

export default RegistrationPageContainer;
